import { IsString, IsBoolean, IsDefined, IsOptional } from 'class-validator';

export class FormPhoneFieldPropsDto {
  @IsOptional()
  @IsString()
  id?: string;

  @IsDefined()
  @IsString()
  label!: string;

  @IsDefined()
  @IsBoolean()
  showLabel!: boolean;

  @IsOptional()
  @IsString()
  placeholder?: string;

  @IsDefined()
  @IsBoolean()
  required!: boolean;

  @IsDefined()
  @IsBoolean()
  hidden!: boolean;

  @IsDefined()
  @IsString()
  helpText!: string;

  @IsDefined()
  @IsBoolean()
  showHelpText!: boolean;

  @IsOptional()
  @IsString()
  defaultCountry?: string;
}
